import { z } from "zod"
import { createSessionStorageItem } from "@/shared/lib/storage"
import { type PlanId, parsePlanId } from "../model/plans"

const BASE_URL = "https://pay.luni.monster"

export type WebPaymentParams = {
	userId: number
	name: string
	avatarUrl: string | null
	planId: PlanId
}

export function buildWebPaymentUrl(params: WebPaymentParams): string {
	const url = new URL(BASE_URL)
	url.searchParams.set("userId", String(params.userId))
	if (params.name) url.searchParams.set("name", params.name)
	if (params.avatarUrl) url.searchParams.set("avatar", params.avatarUrl)
	url.searchParams.set("plan", params.planId)
	return url.toString()
}

export function openWebPaymentUrl(url: string): void {
	window.open(url, "_blank")
}

// Session scope: clearSession removes it on all platforms, Telegram included.
const pendingPlan = createSessionStorageItem<string | null>({
	key: "pending-web-payment",
	schema: z.string().nullable(),
	fallback: null,
})

export function setPendingWebPayment(planId: PlanId): void {
	pendingPlan.set(planId)
}

export function getPendingWebPayment(): PlanId | null {
	return parsePlanId(pendingPlan.get())
}

export function clearPendingWebPayment(): void {
	pendingPlan.remove()
}
